import { render, staticRenderFns } from "./PropertyModalEdit.vue?vue&type=template&id=6c709360"
import script from "./PropertyModalEdit.vue?vue&type=script&lang=js"
export * from "./PropertyModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports